import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Style.css";
import SideBar from "./SideBar";
import { getCurrentTokenClaims } from "../../../api/Tv";

const Layout = ({ children }) => {
    const location = useLocation();
    const currentPath = location.pathname;
    const [currentTime, setCurrentTime] = useState("");

    const tokenClaims = getCurrentTokenClaims();
    const isClient = tokenClaims?.role === 'client' || Boolean(tokenClaims?.tv_id);

    useEffect(() => {
        const updateClock = () => {
            const now = new Date();
            setCurrentTime(now.toLocaleTimeString("en-IN", { hour12: false }) + " IST");
        };
        updateClock();
        const timer = setInterval(updateClock, 1000);
        return () => clearInterval(timer);
    }, []);

    const getPageTitle = () => {
        if (currentPath === "/dashboard") return "Platform Overview";
        if (currentPath === "/tv") return "All TV Channels";
        if (currentPath === "/station") return isClient ? "Station Studio & Banners" : "Client Station Studio & Banners";
        return "Dashboard";
    };

    return (
        <div className="app-container">
            <SideBar />
            <div className="main-layout">
                {/* Modern Topbar */}
                <header className="topbar">
                    <div className="topbar-left">
                        <nav className="breadcrumb-nav">
                            <Link to={isClient ? "/station" : "/dashboard"}>
                                {isClient ? "Station Console" : "NanbaTeam.com"}
                            </Link>
                            <span>/</span>
                            <span className="current">{getPageTitle()}</span>
                        </nav>
                    </div>

                    <div className="topbar-right">
                        <div className="live-pulse-badge">
                            <span className="pulsing-dot"></span>
                            <span>NETWORK ONLINE</span>
                        </div>
                        {currentTime && (
                            <div className="clock-display" title="Live Broadcast Server Time">
                                {currentTime}
                            </div>
                        )}
                        {!isClient && (
                            <Link to="/tv" className="btn btn-primary btn-sm">
                                + New Channel
                            </Link>
                        )}
                    </div>
                </header>

                {/* Content Area */}
                <main className="content-scroller">
                    {children}
                </main>
            </div>
        </div>
    );
};

export default Layout;